import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=18b5ffd3&scoped=true&"
import script from "./Speed.vue?vue&type=script&lang=js&"
export * from "./Speed.vue?vue&type=script&lang=js&"
import style0 from "./Speed.vue?vue&type=style&index=0&id=18b5ffd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5ffd3",
  null
  
)

export default component.exports